import { http } from "config/http";

export const updateFeatureFlagData = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.put("update_features_flags", destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getUserFeatureFlagData = async (name: string) => {
    try {
        const res: any = await http.get(`get_flag_info?user_name=${name}&client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}